import { CommercialCardContentAlignment } from '../../../../../../components/commercialCard/types/commercialCardContentAlignment';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    title: {
        font_variant: TextVariantType.FONT_TITLE_50,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
    },
    titleContainer: {
        margin_bottom: FOUNDATIONS.spacing_100,
    },
    description: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
    },
    highlightIconContainer: {
        display: 'flex',
        align_self: 'center',
    },
    highlightIcon: {
        color: FOUNDATIONS.color_neutral_icon_50,
        backgroundColor: FOUNDATIONS.color_neutral_bg_375,
    },
    buttonContainer: {
        padding_top: FOUNDATIONS.spacing_150,
    },
    linkContainer: {
        display: 'flex',
        flex_direction: 'row',
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_50} ${FOUNDATIONS.spacing_50} ${FOUNDATIONS.spacing_50}`,
    },
    decorativeLinkIcon: {
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_accent_default_secondary_icon_150,
    },
    decorativeLinkText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        font_weight: FONT_WEIGHT.font_weight_600,
        color: FOUNDATIONS.color_accent_default_secondary_font_100,
        text_decoration: 'underline',
    },
    contentAlignment: {
        [CommercialCardContentAlignment.CENTER]: {
            align_items: 'center',
            text_align: 'center',
        },
        [CommercialCardContentAlignment.LEFT]: {
            align_items: 'flex-start',
            text_align: 'left',
        },
    },
});
//# sourceMappingURL=common.js.map